import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-fil-ariane',
  templateUrl: './fil-ariane.component.html',
  styleUrls: ['./fil-ariane.component.scss']
})
export class FilArianeComponent implements OnInit {
  @Input() links: any[];
  @Input() doRedirect = true;
  @Input() actualOrder?: string;
  @Input() displayAll = false;
  @Input() displayHelp = true;
  @Input() hideHR = false;
  @Output() changeLink = new EventEmitter();
  @Output() seeAll = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit() {}

  clickLink(id, index) {
    if (index === this.links.length - 1) {
      return;
    }

    if (this.doRedirect) {
      if (!id) {
        this.router.navigate(['/', 'home', 'my-libraries']);
      } else if (
        this.actualOrder !== undefined &&
        this.actualOrder !== null &&
        this.actualOrder !== '0'
      ) {
        const arr = this.actualOrder.split('.');
        let orderToGo = null;

        if (index === 0) {
          orderToGo = '0';
        } else {
          orderToGo = arr.slice(0, index).join('.');
        }

        this.router.navigate([
          '/',
          'home',
          'my-libraries',
          'lib',
          id
        ]);
      } else {
        this.router.navigate(['/', 'home', 'my-libraries', 'lib', id]);
      }
    } else {
      this.changeLink.emit(id);
    }
  }
}
